var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { assertExists } from '@blocksuite/global/utils';
import { WidgetElement } from '@blocksuite/lit';
import { customElement } from 'lit/decorators.js';
import { getDocPageByEditorHost } from '../../../_common/utils/query.js';
import { PageMetaData } from './components/meta-data.js';
export const AFFINE_DOC_PAGE_META_DATA = 'affine-page-meta-data-widget';
let DocPageMetaDataWidget = class DocPageMetaDataWidget extends WidgetElement {
    connectedCallback() {
        super.connectedCallback();
        this.host.updateComplete
            .then(() => {
            const docPageElement = getDocPageByEditorHost(this.host);
            assertExists(docPageElement);
            const pageMetaData = new PageMetaData(this.page, docPageElement);
            const pageTitleContainer = this.host.querySelector('.affine-doc-page-block-title-container');
            assertExists(pageTitleContainer);
            // FIXME(Flrande): It is not a best practice,
            // but merely a temporary measure for reusing previous components.
            pageTitleContainer.appendChild(pageMetaData);
        })
            .catch(console.error);
    }
};
DocPageMetaDataWidget = __decorate([
    customElement(AFFINE_DOC_PAGE_META_DATA)
], DocPageMetaDataWidget);
export { DocPageMetaDataWidget };
//# sourceMappingURL=doc-page-meta-data.js.map